import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import styles from './Heading.scss';

/**
 * @visibleName Heading 🤯
 */
const Heading = ({ level, margin, children, alignText, fontWeight, hero, ...props }) => {
  const Component = `h${level}`;
  const classProps = classnames(
    styles.heading,
    props.className,
    styles[`heading-size-${level}`],
    styles[`heading-weight-${fontWeight}`],
    styles[`heading-align-${alignText}`],
    {
      [styles['heading-margin']]: margin,
      [styles['heading-hero']]: hero,
    }
  );

  return <Component className={classProps}>{children}</Component>;
};

Heading.defaultProps = {
  alignText: 'left',
  level: 1,
  children: null,
  margin: false,
  hero: false,
  fontWeight: 'normal',
};

Heading.propTypes = {
  /** The Headings H tag */
  level: PropTypes.number,
  /** The Heading alignment */
  alignText: PropTypes.oneOf(['left', 'center', 'right']),
  /** The Heading content */
  children: PropTypes.any,
  /** Optional boolean to add margin around the heading */
  margin: PropTypes.bool,
  /** Optional boolean to add hero around the heading */
  hero: PropTypes.bool,
  fontWeight: PropTypes.oneOf([
    'light',
    'normal',
    'normal-italic',
    'semi-bold',
    'bold',
    'extra-bold',
  ]),
};

export default Heading;
